import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface AdminGuardProps {
  children?: React.ReactNode;
}

/**
 * AdminGuard - Protects admin routes from non-admin users
 *
 * Checks user.is_admin flag and redirects non-admin users to home page
 * Shows loading state during authentication check
 */
export default function AdminGuard({ children }: AdminGuardProps) {
  const { user, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to home if user is not an admin
  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  // Render admin routes - use children if provided, otherwise use Outlet for nested routes
  return children ? <>{children}</> : <Outlet />;
}
